import { mergeStyles } from '@fluentui/react/lib/Styling';

export const placementsOptionStyle = mergeStyles({
  paddingLeft: '26px',
  fontWeight: '100',
});

export const placementsAllSpecificChoiceGroup = mergeStyles({
  marginBottom: '20px',
});

export const placementsCheckboxes = mergeStyles({
  marginBottom: '20px',
});

export const itemStyle = mergeStyles({
  width: '320px',
  border: '1px solid',
  borderRadius: '4px',
  backgroundColor: '#FFFFFF',
  borderColor: '#D1D1D1',
  '&:hover': {
    backgroundColor: '#F5F5F5 !important',
    borderColor: '#BDBDBD !important',
  },
});

export const itemStyleChecked = mergeStyles({
  width: '320px',
  border: '1px solid',
  borderRadius: '4px',
  backgroundColor: 'white !important',
  borderColor: '#BDBDBD !important',
  '&:hover': {
    backgroundColor: '#F5F5F5 !important',
    borderColor: '#BDBDBD !important',
  },
});

export const itemStyleDisabled = mergeStyles({
  width: '320px',
  border: '1px solid',
  borderRadius: '4px',
  backgroundColor: '#F5F5F5 !important',
  borderColor: '#BDBDBD !important',
});

export const placementCard = mergeStyles({
  paddingLeft: '16px',
  width: '280px',
});

export const iconSection = mergeStyles({
  padding: '4px',
  border: 'solid 1px',
  width: '40px',
  height: '40px',
  marginTop: '8px',
  borderColor: 'white',
  backgroundColor: '#F0F0F0',
  '&:hover': {
    backgroundColor: '#E1E4E9 !important',
  },
});

export const iconSectionChecked = mergeStyles({
  padding: '4px',
  border: 'solid 1px',
  width: '40px',
  height: '40px',
  marginTop: '8px',
  borderColor: 'white',
  backgroundColor: '#CFE4FA !important',
  '&:hover': {
    backgroundColor: '#E1E4E9 !important',
  },
});

export const iconSectionDisabled = mergeStyles({
  padding: '4px',
  border: 'solid 1px',
  width: '40px',
  height: '40px',
  marginTop: '8px',
  borderColor: 'white',
  backgroundColor: '#E1E4E9 !important',
});

export const titleStyle = mergeStyles({
  paddingLeft: '16px',
  fontWeight: '600',
  lineHeight: '16px',
});

export const subheaderStyle = mergeStyles({
  paddingLeft: '56px',
  display: 'flex',
  paddingBottom: '12px',
  color: '#616161',
  lineHeight: '0.3',
  fontSize: '13px',
});
